/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { ItemAndItemVariantAssociationResult } from '../../models/item-and-item-variant-association-result';

export interface ItemVariantGroupsItemVariantGroupIdItemSelectionsGet$Params {
  'Active-Tenant-Identifier': string;
  itemVariantGroupId: string;
}

export function itemVariantGroupsItemVariantGroupIdItemSelectionsGet(http: HttpClient, rootUrl: string, params: ItemVariantGroupsItemVariantGroupIdItemSelectionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariant'?: Array<ItemAndItemVariantAssociationResult>;
};
}>> {
  const rb = new RequestBuilder(rootUrl, itemVariantGroupsItemVariantGroupIdItemSelectionsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('itemVariantGroupId', params.itemVariantGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      '_embedded'?: {
      'itemVariant'?: Array<ItemAndItemVariantAssociationResult>;
      };
      }>;
    })
  );
}

itemVariantGroupsItemVariantGroupIdItemSelectionsGet.PATH = '/item-variant-groups/{itemVariantGroupId}/item-selections';
